import { render, staticRenderFns } from "./UserSegmentation.vue?vue&type=template&id=89d4e254&scoped=true&"
import script from "./UserSegmentation.vue?vue&type=script&lang=js&"
export * from "./UserSegmentation.vue?vue&type=script&lang=js&"
import style0 from "./UserSegmentation.vue?vue&type=style&index=0&id=89d4e254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d4e254",
  null
  
)

export default component.exports